import React from 'react';
import { CloseIcon } from '../assets/svg/MenuIcons';

interface ResetModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const ResetPassword: React.FC<ResetModalProps> = ({ isOpen, onClose }) => {
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      aria-labelledby="modal-title"
      aria-modal="true"
      role="dialog"
    >
      <div
        id="Locked-Account-Modal"
        className="bg-white p-6 rounded-lg max-w-xs mx-auto relative"
        role="alert"
      >
        <div className="flex justify-center mb-4">
          <div className="border-2 border-primary-red rounded-full p-3">
            <span className="">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 34 34"
                fill="none"
              >
                <path
                  d="M2.83341 26.916V24.0827H31.1667V26.916H2.83341ZM4.46258 18.3452L2.62091 17.2827L3.82508 15.1577H1.41675V13.0327H3.82508L2.62091 10.9785L4.46258 9.91602L5.66675 11.9702L6.87091 9.91602L8.71258 10.9785L7.50841 13.0327H9.91675V15.1577H7.50841L8.71258 17.2827L6.87091 18.3452L5.66675 16.2202L4.46258 18.3452ZM15.7959 18.3452L13.9542 17.2827L15.1584 15.1577H12.7501V13.0327H15.1584L13.9542 10.9785L15.7959 9.91602L17.0001 11.9702L18.2042 9.91602L20.0459 10.9785L18.8417 13.0327H21.2501V15.1577H18.8417L20.0459 17.2827L18.2042 18.3452L17.0001 16.2202L15.7959 18.3452ZM27.1292 18.3452L25.2876 17.2827L26.4917 15.1577H24.0834V13.0327H26.4917L25.2876 10.9785L27.1292 9.91602L28.3334 11.9702L29.5376 9.91602L31.3792 10.9785L30.1751 13.0327H32.5834V15.1577H30.1751L31.3792 17.2827L29.5376 18.3452L28.3334 16.2202L27.1292 18.3452Z"
                  fill="#DA291C"
                />
              </svg>
            </span>
          </div>
        </div>
        <h2 id="modalTitle" className="text-xl font-bold text-center">
          Reset your password
        </h2>
        <p
          id="modalDescription"
          className="text-sm text-gray-600 text-center mt-2"
        >
          You have exceeded the number of login attempts. Reset your password to
          continue.
        </p>

        <button
          onClick={() => {
            console.log('clicked');
          }}
          className=" text-text16 font-[600] mt-10 bg-red-600 text-white py-2 px-4 hover:bg-red-700 focus:outline-none w-full"
        >
          Reset now
        </button>

        <div className="absolute top-5 right-5" onClick={onClose}>
          <CloseIcon width={'24'} height="24" fill="#1F1F1F" />
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
